import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import {
  EditCardRequest,
  MySignedCardsResponse,
} from "tng-address-collection-shared/types/apiTypes.ts";
import { getSenderDisplayName } from "./getSenderSignature.ts";
import { queryKeys } from "./queryKeys.ts";

export const useEditCardMySignedCardsCache = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (newCard: EditCardRequest) => {
      queryClient.setQueryData<MySignedCardsResponse>(
        queryKeys.mySignedCards(),
        (old) =>
          old && {
            cards: old.cards.map((card) =>
              card.id === newCard.id
                ? {
                    ...card,
                    firstName: newCard.recipient.firstName,
                    lastName: newCard.recipient.lastName,
                    companyName: newCard.recipient.companyName,
                    senderDisplayName: getSenderDisplayName(
                      queryClient,
                      newCard.senderId,
                    ),
                  }
                : card,
            ),
          },
      );
    },
    [queryClient],
  );
};
